import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  MODULE_REGISTRATION,
  MODULE_REGISTRATION_ALL,
  MODULE_REGISTRATION_LIST,
} from '../constants/actionTypes'

const moduleRegistrationSelectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const moduleRegistrationSelector = createSelector(moduleRegistrationSelectors, data => data[MODULE_REGISTRATION])

export const moduleRegistrationListSelector = createSelector(
  moduleRegistrationSelectors,
  data => data[MODULE_REGISTRATION_LIST]
)

export const moduleRegistrationAllSelector = createSelector(
  moduleRegistrationSelectors,
  data => data[MODULE_REGISTRATION_ALL]
)
